import dateformat from "dateformat";

export const dateFormats = {
  long: "dddd, mmmm dS, yyyy, h:MM:ss TT",
  isoDate: "yyyy-mm-dd HH:MM:ss",
  date: "dd/mm/yyyy",
  dateTime: "yyyy-mm-dd HH:MM",
  time: "HH:MM:ss",
};

export const formatDate = (date, formatStr) => {
  // let d = date;
  // if (!date.getTime) {
  let d = new Date(date);
  // }
  //Todo: ago
  return dateformat(d, formatStr);
};
